module.exports = __webpack_public_path__ + "img/20220420161432.70181a10.png";